var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"profile-image",style:(_vm.imgStyle),attrs:{"alt":"Profile Picture","src":_vm.profileImageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }